import pdfI from '../OtherResourses/COMPARATIVA_PLANES.pdf'

export const pdf = pdfI
